import { Buttons, FlexContainer, Icon, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import * as Styled from './styles';
import { ServiceType } from './types';

const Service = ({
  icon,
  title,
  description,
  buttonLabel,
  action,
  id,
}: ServiceType): JSX.Element => {
  const { t } = useTranslation(locizeNS.ACCOUNT);

  return (
    <Styled.Service direction="column" gap="dimension_16">
      <Icon icon={icon} color="secondary" />
      <FlexContainer direction="column" gap="dimension_08">
        <Text type="paragraphs" color="dark" size="S_L_S">
          {t(title)}
        </Text>
        <Text type="paragraphs" color="grey" size="XS_M_M">
          {t(description)}
        </Text>
      </FlexContainer>
      {buttonLabel && (
        <FlexContainer>
          <Buttons.Contextual label={t(buttonLabel)} mode="primary" id={id} onClick={action} />
        </FlexContainer>
      )}
    </Styled.Service>
  );
};

export default Service;
